import { Component, Input } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { configs } from 'src/app/configs/app.config';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent  {

  public cardType: Object = configs['cardType'];

  constructor(public globalService: GlobalService, private httpService: HttpService) {
    setTimeout(()=>{
      if (this.globalService && this.globalService.order_id)
      this.fetchAlertList();
    else {
      let inter = setInterval(() => {
        if (this.globalService && this.globalService.order_id) {
          clearInterval(inter);
          this.fetchAlertList();
        }
      }, 100);
    }
    },0);
  }

  forPopupOpen(alert, key) {
    if(alert){
        this.httpService.createPutRequest(configs['api']['markAsViewed'] + this.globalService.order_id + "/" +alert['alertId']+"?viewed=true",{},'')
          .subscribe((res) => {
            if (res) {
              this.globalService.alertDetails = alert;
              this.globalService.showPopUp = key;
              document.body ? document.body.classList.add('no-scroll') : '';  
            }
          });
    }else{
      this.globalService.alertDetails = alert;
      this.globalService.showPopUp = key;
      document.body ? document.body.classList.add('no-scroll') : '';   
    }
  
  }

  forPopupClose() {
    this.globalService.showPopUp = "";
    document.body ? document.body.classList.remove('no-scroll') : '';
  }



  public alertList: Array<any> = [];
  public fetchAlertList(): void {
    this.alertList = [];
    let url = configs['api']['fetchAlertList'] + this.globalService.order_id + '?satisfied=true';
    
    this.httpService.createGetRequest(url)
      .subscribe((res) => {
        if (res && res['list']) {
          this.alertList = res['list'];
        }
      });
  }
}

